import { createRouter, createWebHashHistory } from 'vue-router';
import { restapi } from '@/libs/restapi.mjs';
import GetItems from '../components/GetItems.vue';
import HomeView from '../components/views/coda/HomeView.vue';
import AboutView from '../components/views/coda/AboutView.vue';
import LoginView from '@/components/views/coda/LoginView.vue';
import SongRegistration from '../components/views/coda/SongRegistration.vue';
import SongReg1 from '@/components/views/coda/songreg/SongReg1.vue';
import SongReg2 from '@/components/views/coda/songreg/SongReg2.vue';
import SongReg3 from '@/components/views/coda/songreg/SongReg3.vue';
import SongRegConfirmAndSave from '@/components/views/coda/songreg/SongRegConfirmAndSave.vue';
import SongRegUserSummary from '@/components/views/coda/songreg/SongRegUserSummary.vue';
import { useUserStore } from './stores';
import LogoutView from '@/components/views/coda/LogoutView.vue';
const routes = [
    {
        path: '/',
        component: LoginView,
        meta: { requiresAuth: false }
    },
    {
        path: '/home',
        component: HomeView,
        meta: { requiresAuth: true },
    },
    // {
    //   path: '/login', 
    //   component: LoginView ,
    //   meta: { requiresAuth: false },
    // },
    {
        path: '/logout',
        component: LogoutView,
        meta: { requiresAuth: false },
    },
    {
        path: '/songde',
        component: SongRegistration,
        meta: { requiresAuth: true },
        children: [
            {
                name: 'srsummary',
                path: 'srsummary',
                component: SongRegUserSummary,
            },
            {
                name: 'reginfo',
                path: 'reginfo',
                component: SongReg1,
            },
            {
                name: 'pubs',
                path: 'pubs',
                component: SongReg2,
            },
            {
                name: 'wrtrs',
                path: 'wrtrs',
                component: SongReg3,
            },
            {
                name: 'summary',
                path: 'summary',
                component: SongRegConfirmAndSave,
            }
        ]
    },
    {
        path: '/about',
        component: AboutView,
        meta: { requiresAuth: false },
    },
    {
        path: '/getitems',
        component: GetItems,
        meta: { requiresAuth: true },
    }
];
const router = createRouter({
    history: createWebHashHistory(),
    routes,
});
router.beforeEach(async (to) => {
    // instead of having to check every route record with
    // to.matched.some(record => record.meta.requiresAuth)
    // console.log(to.meta);
    // console.log(authenticatedUser)
    // eslint-disable-next-line
    const userStore = useUserStore();
    if (to.meta.requiresAuth && !userStore.user?.sub) {
        // this route requires auth, check if logged in
        // if not, redirect to login page.
        return {
            path: '/',
            // save the location we were at to come back later
            query: { redirect: to.fullPath },
        };
    }
});
router.beforeEach(async (to) => {
    const userStore = useUserStore();
    console.log("routing...", to.path);
    if (to.name === 'srsummary' && userStore.user?.sub) {
        try {
            if (userStore.songRegistrations?.length === 0 || userStore.songRegistrations === undefined) {
                const response = await restapi.getAllUserSongRegsA({ keyFob: userStore.user.sub });
                // console.log(response);
                if (response?.item) {
                    userStore.songRegistrations = response.item;
                }
            }
        }
        catch (err) {
            console.log(err);
        }
    }
});
export default router;
